import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=0ef4fc77"
import script from "./side-menu-item.vue?vue&type=script&lang=js"
export * from "./side-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports